<script>
  import {
    inputWrapper,
    inputLabel,
    input,
    inputErrMsg,
  } from "./BaseInput.style.js";

  export let inputValue = "";
  export let label = "label";
  export let name;
  export let type = "text";
  export let error = {
    required: false,
    status: false,
    msg: "",
  };

  let inputFocusAndBlur = {
    focus: false,
    onFocus: () => {
      inputFocusAndBlur.focus = true;
    },
    onBlur: () => {
      inputFocusAndBlur.focus = false;
    },
  };
</script>

<div
  class={inputWrapper}
  class:focused={inputFocusAndBlur.focus}
  class:error={error.status}>
  <label for={label} class={inputLabel}>{label}</label>
  <input
    {type}
    id={label}
    {name}
    value={inputValue}
    class={input}
    autocomplete="off"
    on:focus={inputFocusAndBlur.onFocus}
    on:blur={inputFocusAndBlur.onBlur}
    on:beforeinput
    on:keypress
    on:input />
</div>
{#if error.status && error.required}
  <span class={inputErrMsg}>{error.msg}</span>
{/if}
